site.extras.filter = {
	init:function(layout) {
		// quick search regex
		var qsRegex;

// init Isotope
		var $grid = $('#extras .items').isotope({
			itemSelector: '.item',
			layoutMode: 'fitRows',
			filter: function() {
				var $this = $(this);
				var searchResult = qsRegex ? $this.text().match( qsRegex ) : true;

				var bf = location.hash;
				bf = (bf == '') ? '#all' : bf;

				var buttonResult = true;

				if (bf) {
					bf = bf.substr(1, bf.length);
					if (bf === 'all') {
						buttonResult = true;
					}
					else if (!$this.hasClass(bf)) {
						buttonResult = false;
					}
				}

				return searchResult && buttonResult;
			}
		});

		// use value of search field to filter
		var $quicksearch = $('.quicksearch').keyup( debounce( function() {
			qsRegex = new RegExp( $quicksearch.val(), 'gi' );
			$grid.isotope();
		}) );

		$(function () {
			$(window).bind("hashchange", function (e) {
				$('#itemFilter li').removeClass('selected');
				var b = location.hash;
				b = (b == '') ? '#all' : b;

				if (b) {
					b = b.substr(1, b.length);
					var filterValue = (b == 'all') ? '*' : '.' + b;
					var $container = $('#extras .items');
					$container.isotope();
					$("#itemFilter ." + b).attr('selected', 'selected');
					$("#itemFilter ." + b).addClass('selected');
				}
			});
			$(window).trigger("hashchange");
		});


		// debounce so filtering doesn't happen every millisecond
		function debounce( fn, threshold ) {
			var timeout;
			return function debounced() {
				if ( timeout ) {
					clearTimeout( timeout );
				}
				function delayed() {
					fn();
					timeout = null;
				}
				setTimeout( delayed, threshold || 100 );
			};
		}
	}
};
//site.inits.push('site.extras.filter.init()');